import { useState } from "react";

interface PanelDef {
  id: string;
  label: string;
}

const PANELS: PanelDef[] = [
  { id: "crew", label: "Crew" },
  { id: "status", label: "Status" },
  { id: "tactical", label: "Tactical" },
  { id: "comms", label: "Comms" },
  { id: "log", label: "Log" },
];

interface Props {
  visible: Set<string>;
  onToggle: (id: string) => void;
  onReset: () => void;
}

export function PanelManager({ visible, onToggle, onReset }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="panel-manager">
      <button
        className="panel-manager__trigger"
        onClick={() => setOpen(o => !o)}
        title="Panel Manager"
      >
        {open ? "✕" : "☰"}
      </button>

      {open && (
        <div className="panel-manager__menu">
          <div className="panel-manager__title">PANELS</div>
          {PANELS.map(p => (
            <label key={p.id} className="panel-manager__item">
              <input
                type="checkbox"
                checked={visible.has(p.id)}
                onChange={() => onToggle(p.id)}
              />
              <span>{p.label}</span>
            </label>
          ))}
          <button className="panel-manager__reset" onClick={onReset}>
            RESET LAYOUT
          </button>
        </div>
      )}
    </div>
  );
}
